import React, { memo, useCallback, useEffect, useState } from 'react'
import TextInput from './atoms/textFields/TextInput'
import classes from './HeaderController.module.scss'
import axios from 'axios'
import { ErrorModal } from '../uikit/atoms/ErrorModal'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { loadingText, loadingState } from '../../states/LoadingState'
import {
  documentNamesState,
  drawingNamesState,
  excludeDocumentNamesState,
  excludeDrawingNamesState,
  factoriesState,
  productItemsState,
  userState,
} from '../../states/userState'
import TextInputForProductNo from './atoms/textFields/TextInputForProductNo'
import TextInputForproductBno from './atoms/textFields/TextInputForProductBno'
import {
  foreColor,
  foreColorCodePagination,
  foreColorOnMouseOver,
  foreColorPagination,
} from '../../commons/colors'
import SearchIcon from '@mui/icons-material/Search'
import { setUserToLocalStorage } from '../../functions/localStorageManager'
import UpdateDateFilter from './organisms/UpadteDateFilter'
import LatestSwitch from './atoms/LatestSwitch'
import { InvalidProductNo, productNoState } from '../../states/poductNoState'
import TextInputWithNoSearch from './atoms/textFields/TextInputWithNoSearch'
import apiClient from '../../lib/apiClient'
import { Tooltip } from '@mui/material'
import SetDetailParams from './modal/SetDetailParams'
import { factories as factoryList } from '../../commons/factories'

const HeaderController = memo((props) => {
  const { setKintoneArray, setHasMore } = props
  const recoilProductNo = useRecoilValue(productNoState)
  const [isHovered, setIsHovered] = useState(false)
  const [isDetailHovered, setIsDetailHovered] = useState(false)
  const [user, setUser] = useRecoilState(userState)
  const [toggleFocus, setToggleFocus] = useState(false)
  const [productNo, setProductNo] = useState(
    recoilProductNo.productNo &&
      recoilProductNo.productNo !== InvalidProductNo.productNo
      ? recoilProductNo.productNo
      : user.filters.productNo.split('-')[0]
      ? user.filters.productNo.split('-')[0]
      : ''
  )
  const [productBo, setProductBo] = useState(
    recoilProductNo.productBno &&
      recoilProductNo.productBno !== InvalidProductNo.productBno
      ? recoilProductNo.productBno
      : user.filters.productNo.split('-')[1]
      ? user.filters.productNo.split('-')[1]
      : ''
  )
  const [isShowErrorDialog, setIsShowErrorDialog] = useState(false)
  const [isShowDetailDialog, setIsShowDetailDialog] = useState(false)
  const [title, setTitle] = useState('APIエラー')
  const [message, setMessage] = useState('レコードの取得に失敗しました')
  const setLoadingAnimation = useSetRecoilState(loadingState)
  const setLoadingText = useSetRecoilState(loadingText)
  const drawingNames = useRecoilValue(drawingNamesState)
  const excludeDrawingNames = useRecoilValue(excludeDrawingNamesState)
  const documentNames = useRecoilValue(documentNamesState)
  const excludeDocumentNames = useRecoilValue(excludeDocumentNamesState)
  const factories = useRecoilValue(factoriesState)
  const productItems = useRecoilValue(productItemsState)
  const headquartersId = factoryList.find((f) => f.name === '本社工場')?.id
  //クエリ取得
  useEffect(() => {
    if (!user.isAuth) return
    ;(async () => {
      if (
        recoilProductNo.productNo !== InvalidProductNo.productNo &&
        recoilProductNo.productBno !== InvalidProductNo.productBno &&
        (recoilProductNo.productNo !== '' || recoilProductNo.productBno !== '')
      )
        await fetchDrafts()
    })()
    setProductNo(
      recoilProductNo.productNo &&
        recoilProductNo.productNo !== InvalidProductNo.productNo
        ? recoilProductNo.productNo
        : user.filters.productNo.split('-')[0]
        ? user.filters.productNo.split('-')[0]
        : ''
    )
    setProductBo(
      recoilProductNo.productNo &&
        recoilProductNo.productBno !== InvalidProductNo.productBno
        ? recoilProductNo.productBno
        : user.filters.productNo.split('-')[1]
        ? user.filters.productNo.split('-')[1]
        : ''
    )
  }, [recoilProductNo])

  const fetchDrafts = useCallback(async () => {
    const requestBody = {
      productNo:
        recoilProductNo.productNo &&
        recoilProductNo.productNo !== InvalidProductNo.productNo
          ? recoilProductNo.productNo
          : user.filters.productNo.split('-')[0]
          ? user.filters.productNo.split('-')[0]
          : '',
      productBno:
        recoilProductNo.productNo &&
        recoilProductNo.productBno !== InvalidProductNo.productBno
          ? recoilProductNo.productBno
          : user.filters.productNo.split('-')[1]
          ? user.filters.productNo.split('-')[1]
          : '',
      keywords: user.filters.keywords,
      fromDate: user.filters.isUpdateEnable ? user.filters.drawingUpdFrm : '',
      toDate: user.filters.isUpdateEnable ? user.filters.drawingUpdTo : '',
      factories: factories?.length ? factories : [headquartersId],
      productItems,
      drawingNames,
      excludeDrawingNames,
      documentNames,
      excludeDocumentNames,
    }

    try {
      setLoadingAnimation(true)
      setLoadingText('取得中...')
      const startTime = Date.now() // リクエスト前の時刻を記録
      const res = await apiClient.post(
        '/Drawing/getDrawingByDetailParams',
        requestBody
      )
      const endTime = Date.now() // リクエスト後の時刻を記録
      const duration = endTime - startTime // ミリ秒単位での時間差を計算
      console.log(`APIのフェッチ時間: ${duration}ms`)
      console.log('res.data', res.data, 'productNo', productNo)
      setKintoneArray(res.data.records)
      setHasMore(res.data.hasMore)
      setIsShowErrorDialog(false)
    } catch (error) {
      setIsShowErrorDialog(true)
      setHasMore(false)
      // window.alert(error);
    } finally {
      setLoadingAnimation(false)
      setLoadingText('')
    }
  }, [user.filters, recoilProductNo])
  useEffect(() => {
    console.log(isHovered)
  }, [isHovered])

  const inputKeywords = (e) => {
    const value = e.target.value
    setUser((prevUser) => {
      const newUser = {
        ...prevUser,
        filters: {
          ...prevUser.filters,
          keywords: value,
        },
      }
      setUserToLocalStorage(newUser)
      // table.setPageIndex(1);
      return newUser
    })
  }

  return (
    <>
      <div className={classes.rootContainer}>
        <div className={classes.filters}>
          <div className={classes.productNo}>
            <div style={foreColorPagination(user?.mode ?? 'lite')}>製作NO</div>
            <div className={classes.textInput}>
              <div>
                <TextInputForProductNo
                  fullWidth={false}
                  label={''}
                  type={'number'}
                  multiline={false}
                  required={false}
                  rows={1}
                  disabled={false}
                  placeholder={'01234567'}
                  setProductNo={setProductNo}
                  productNo={productNo}
                  setProductBno={setProductBo}
                  productBno={productBo}
                  setToggleFocus={setToggleFocus}
                  setKintoneArray={setKintoneArray}
                  // InputProps={true}
                />
              </div>
              <p style={foreColor(user?.mode ?? 'lite')}>－</p>
              <div>
                <TextInputForproductBno
                  fullWidth={false}
                  label={''}
                  multiline={false}
                  required={false}
                  type={'number'}
                  rows={1}
                  disabled={false}
                  // InputProps={true}
                  placeholder={'01'}
                  setProductNo={setProductNo}
                  productNo={productNo}
                  setProductBno={setProductBo}
                  productBno={productBo}
                  toggleFocus={toggleFocus}
                  setKintoneArray={setKintoneArray}
                />
              </div>
            </div>
          </div>
          <div className={classes.dateSelector}>
            <UpdateDateFilter />
          </div>

          <div className={classes.latestOnly}>
            <LatestSwitch />
          </div>
          <div className={classes.buttons}>
            <Tooltip title="製作工場 品目 図面 文書">
              <div
                style={{
                  // backgroundColor: "#09a0f2",
                  backgroundColor: isDetailHovered ? '#ff0' : '#09a0f2',
                  width: '100px',
                  height: '38px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  marginRight: '20px',
                  marginTop: '-5px',
                }}
                onMouseEnter={() => setIsDetailHovered(true)} // マウスが要素に入ったらホバー状態をtrueに
                onMouseLeave={() => setIsDetailHovered(false)} // マウスが要素から出たらホバー状態をfalseに
                onClick={() => setIsShowDetailDialog(true)}
              >
                詳細設定
              </div>
            </Tooltip>
          </div>
          <div className={classes.buttons}>
            <div
              style={{
                // backgroundColor: "#09a0f2",
                backgroundColor: isHovered ? '#ff0' : '#09a0f2',
                width: '36px',
                height: '30px',
                paddingLeft: '6px',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
              onMouseEnter={() => setIsHovered(true)} // マウスが要素に入ったらホバー状態をtrueに
              onMouseLeave={() => setIsHovered(false)} // マウスが要素から出たらホバー状態をfalseに
              onClick={fetchDrafts}
            >
              <SearchIcon />
            </div>
          </div>
        </div>
      </div>
      {isShowErrorDialog && (
        <ErrorModal
          title={title}
          message={message}
          setIsShow={setIsShowErrorDialog}
        />
      )}
      {isShowDetailDialog && (
        <SetDetailParams
          isShow={isShowDetailDialog}
          setIsShow={setIsShowDetailDialog}
          setKintoneArray={setKintoneArray}
          setHasMore={setHasMore}
        />
      )}
    </>
  )
})

export default HeaderController
